import { useEffect } from 'react';
import './App.css';
import { Game } from './Game/Game.js';


/**
 * TODO: What if we make this multiplayer so Binca & I can play together?
 */
function App() {

  useEffect(()=>{
  
    const tinyWidth = document.getElementById('tiny-tag').style.width
    document.getElementById('header').style.left += tinyWidth
  },[]);

  return (
    <div id='app' className="App">
      <div id="header" style={{display:'flex', flexDirection:'row', justifyContent:'flex-end'}}><h1>BINCA BLOCK</h1><p id="tiny-tag">tiny edition</p></div>
      <Game></Game>
    </div>
  );
}

export default App;
